import React, {useContext, useState} from "react";
import Cookies from "js-cookie";
import getPublicUrl from "utils/publicUrl";

const logo_ordago = 'logo-ordago.png';
const picto_ordago = 'picto-ordago.png';
const logo_organization = {}
logo_organization['c10ecf0e-7459-4953-b8f0-beffca8805c3'] = {logo: logo_ordago, picto: picto_ordago};  // Ordago
logo_organization['006ce816-45d7-454e-9e96-2f8e0f36d419'] = {logo: 'logo-ona.png', picto: 'picto-ona.png'}; // ONA


// import {Button, Grid, TextField} from "@material-ui/core";
// import axios from "../../axiosConfig";


export const LogoForTools = (props) => {
    const publicUrl = getPublicUrl();
    const [logoTools, setLogoTools] = React.useState(logo_ordago);
    const [organization, setOrganization] = React.useState(localStorage.getItem("actual_organization") && JSON.parse(localStorage.getItem("actual_organization")));
    React.useEffect(() => {
        if (organization?.id) {
            logo_organization?.[organization?.id]?.logo ? setLogoTools(logo_organization[organization?.id]?.logo) : setLogoTools(logo_ordago)
        }
    }, [organization])
    React.useEffect(() => {
        if (props.actualSite?.id) {
            logo_organization?.[props.actualSite?.id]?.logo ? setLogoTools(logo_organization[props.actualSite?.id]?.logo) : setLogoTools(logo_ordago)
        }
    }, [props.actualSite])

    return (
        <>
            <img
                style={props.style}
                src={`${publicUrl}/logo/${props.folder}/${logoTools}`}
                alt="Logo"/>
        </>)
}

export const LogoSwitchAccount = (props) => {
    const publicUrl = getPublicUrl();
    const {login} = useContext(props.AuthContext);
    const [wrong, setWrong] = useState(undefined);
    const [error, setError] = useState(undefined);
    const handleExportLinkCsv = (e, userid) => {
        login({username: null, password: null, userid: userid}).then(reponse => {
            window.location.reload(false);
        }).catch(err => {
            if (err.response) {
                setWrong(err.response.data.errors)
                if (err.response.status === 500) {
                    setError(true)
                }
            }
        })
    };

    return (
        <>
            {props.accountSwitch.map((data, idx) => (
                <span key={idx}>
            <img
                style={props.style}
                src={`${publicUrl}/logo/${props.folder}/logo-${data.account.name}.png`}
                onClick={e => handleExportLinkCsv(e, data.account.id)}
            />
          </span>

            ))}
        </>)
}

export const PictoForTools = (props) => {
    const publicUrl = getPublicUrl();
    const [pictoTools, setPictoTools] = React.useState(picto_ordago);
    React.useEffect(() => {
        if (Cookies.get('parent_account')) {
            let parent_account = JSON.parse(Cookies.get('parent_account'))
            setPictoTools(parent_account['picto'])
        }
    }, [pictoTools])
    return (
        <>
            <img
                style={props.style}
                src={`${publicUrl}/logo/${props.folder}/${pictoTools}`}
                alt="Picto"/>
        </>)
}

